// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  admin/src/utils/api.js  —  Quickry Admin
//  Copy to: C:\quickry\admin\src\utils\api.js
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

// ✅ FIX: localhost nahi — api.quickry.in use karo
// localhost sirf us PC pe kaam karta hai jahan backend chal raha ho
const BASE = "https://quickry-ivrv.onrender.com/api";

const getToken = () =>
  localStorage.getItem("adminToken") || localStorage.getItem("token") || "";

const req = async (method, url, body = null) => {
  try {
    const res = await fetch(`${BASE}${url}`, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    const data = await res.json();
    return data;
  } catch (e) {
    return { success: false, message: e.message };
  }
};

export const api = {
  // ── Dashboard ─────────────────────────────────
  dashboard: () => req("GET", "/admin/dashboard"),

  // ── Auth ──────────────────────────────────────
  auth: {
    login: (data) => req("POST", "/admin/login", data),
  },

  // ── Restaurants ───────────────────────────────
  restaurants: {
    getAll:  ()           => req("GET",    "/restaurants"),
    getOne:  (id)         => req("GET",    `/restaurants/${id}`),
    create:  (data)       => req("POST",   "/restaurants", data),
    update:  (id, data)   => req("PUT",    `/restaurants/${id}`, data),
    delete:  (id)         => req("DELETE", `/restaurants/${id}`),
    toggle:  (id)         => req("PATCH",  `/restaurants/${id}/toggle`),
  },

  // ── Menu ──────────────────────────────────────
  menu: {
    getByRestaurant: (rid)      => req("GET",    `/menu/restaurant/${rid}`),
    create:          (data)     => req("POST",   "/menu", data),
    update:          (id, data) => req("PUT",    `/menu/${id}`, data),
    delete:          (id)       => req("DELETE", `/menu/${id}`),
    toggle:          (id)       => req("PATCH",  `/menu/${id}/toggle`),
  },

  // ── Orders ────────────────────────────────────
  orders: {
    getAll:       (query = "") => req("GET",   `/orders?${query}`),
    getOne:       (id)         => req("GET",   `/orders/${id}`),
    updateStatus: (id, data)   => req("PATCH", `/orders/${id}/status`, data),
    cancel:       (id, data)   => req("PATCH", `/orders/${id}/cancel`, data),
  },

  // ── Courier ───────────────────────────────────
  courier: {
    getAll:       (query = "") => req("GET",   `/courier?${query}`),
    updateStatus: (id, data)   => req("PATCH", `/courier/${id}/status`, data),
  },

  // ── Riders ────────────────────────────────────
  riders: {
    getAll:       (query = "") => req("GET",    `/riders?${query}`),
    getOne:       (id)         => req("GET",    `/riders/${id}`),
    create:       (data)       => req("POST",   "/riders", data),
    update:       (id, data)   => req("PUT",    `/riders/${id}`, data),
    delete:       (id)         => req("DELETE", `/riders/${id}`),
    toggle:       (id)         => req("PATCH",  `/riders/${id}/toggle`),
    verify:       (id)         => req("PATCH",  `/riders/${id}/verify`),
    assignOrder:  (data)       => req("POST",   "/riders/assign-order", data),
    getAvailable: ()           => req("GET",    "/riders/available-for-assign"),
  },

  // ── Users ─────────────────────────────────────
  users: {
    getAll:  (query = "") => req("GET",   `/users?${query}`),
    getOne:  (id)         => req("GET",   `/users/${id}`),
    toggle:  (id)         => req("PATCH", `/users/${id}/toggle`),
  },

  // ── Vendors ───────────────────────────────────
  vendors: {
    getAll:       (query = "") => req("GET",   `/vendors?${query}`),
    updateStatus: (id, data)   => req("PUT",   `/vendors/${id}/status`, data),
    approve:      (id)         => req("PATCH", `/vendors/${id}/approve`),
    reject:       (id, data)   => req("PATCH", `/vendors/${id}/reject`, data),
    review:       (id)         => req("PATCH", `/vendors/${id}/review`),
  },

  // ── Coupons ───────────────────────────────────
  coupons: {
    getAll:   ()          => req("GET",    "/coupons"),
    create:   (data)      => req("POST",   "/coupons", data),
    update:   (id, data)  => req("PUT",    `/coupons/${id}`, data),
    delete:   (id)        => req("DELETE", `/coupons/${id}`),
    toggle:   (id)        => req("PATCH",  `/coupons/${id}/toggle`),
    validate: (data)      => req("POST",   "/coupons/validate", data),
  },

  // ── Notifications ─────────────────────────────
  notifications: {
    getAll:  ()     => req("GET",    "/notifications"),
    create:  (data) => req("POST",   "/notifications", data),
    delete:  (id)   => req("DELETE", `/notifications/${id}`),
  },

  // ── Categories ────────────────────────────────
  categories: {
    getAll:     ()           => req("GET",    "/categories"),
    createMain: (data)       => req("POST",   "/categories/main", data),
    updateMain: (id, data)   => req("PUT",    `/categories/main/${id}`, data),
    deleteMain: (id)         => req("DELETE", `/categories/main/${id}`),
    getSub:     (mainId)     => req("GET",    `/categories/sub?mainCategory=${mainId}`),
    createSub:  (data)       => req("POST",   "/categories/sub", data),
    updateSub:  (id, data)   => req("PUT",    `/categories/sub/${id}`, data),
    deleteSub:  (id)         => req("DELETE", `/categories/sub/${id}`),
  },

  // ── Grocery ───────────────────────────────────
  grocery: {
    stores: {
      getAll:  ()           => req("GET",    "/grocery/stores"),
      getOne:  (id)         => req("GET",    `/grocery/stores/${id}`),
      create:  (data)       => req("POST",   "/grocery/stores", data),
      update:  (id, data)   => req("PUT",    `/grocery/stores/${id}`, data),
      delete:  (id)         => req("DELETE", `/grocery/stores/${id}`),
      toggle:  (id)         => req("PATCH",  `/grocery/stores/${id}/toggle`),
    },
    products: {
      getByStore:  (sid)           => req("GET",    `/grocery/stores/${sid}/products`),
      create:      (sid, data)     => req("POST",   `/grocery/stores/${sid}/products`, data),
      update:      (sid, id, data) => req("PUT",    `/grocery/stores/${sid}/products/${id}`, data),
      delete:      (sid, id)       => req("DELETE", `/grocery/stores/${sid}/products/${id}`),
    },
  },

  // ── Banners ───────────────────────────────────
  banners: {
    getAll:  ()          => req("GET",    "/banners/all"),
    create:  (data)      => req("POST",   "/banners", data),
    update:  (id, data)  => req("PUT",    `/banners/${id}`, data),
    delete:  (id)        => req("DELETE", `/banners/${id}`),
    toggle:  (id)        => req("PATCH",  `/banners/${id}/toggle`),
  },
};